import { Link } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import { Compass, ArrowRight } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="not-found-page">
      <PublicHeader />
      <main className="max-w-2xl mx-auto px-6 py-24 text-center">
        <Compass size={64} weight="fill" className="text-[#B47A3C] mx-auto mb-6" />
        <p className="label-caps text-[#B47A3C] mb-2">404 · Off the map</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05] font-medium mb-4">
          This trail went <span className="italic text-[#B47A3C]">cold.</span>
        </h1>
        <p className="text-lg text-[#525252] leading-relaxed mb-8">
          The page you're looking for isn't here — but like any good picker, you know the best finds are one
          aisle over.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/" data-testid="notfound-home" className="h-13 px-7 py-3.5 bg-[#0D1B2A] text-[#FDFBF7] rounded-none font-medium inline-flex items-center gap-2 hover:bg-black transition-transform active:scale-95">
            Back to the landing <ArrowRight size={17} weight="bold" />
          </Link>
          <Link to="/dashboard" data-testid="notfound-dashboard" className="h-13 px-7 py-3.5 border-2 border-[#0D1B2A] text-[#0D1B2A] rounded-none font-medium inline-flex items-center hover:bg-[#0D1B2A] hover:text-[#FDFBF7] transition-colors">
            My dashboard
          </Link>
        </div>
      </main>
    </div>
  );
}
